import { Children, cloneElement, PropsWithChildren, ReactElement } from 'react';

export interface ProvidersProps extends PropsWithChildren {
  providers: ReactElement[] | ReactElement;
}

export const Providers = ({ children, providers }: ProvidersProps) => {
  const providersArray = Array.isArray(providers)
    ? providers
    : Children.toArray((providers.props as PropsWithChildren).children);
  return providersArray.reduceRight(
    (acc, provider) => cloneElement(provider as ReactElement, undefined, acc),
    children,
  );
};
